import React from 'react';

import CSSModules from 'react-css-modules';

import styles from './styles.module.scss';

type EndProps = {
  headingText: string;
  completionText?: string;
};

const End = ({headingText, completionText}: EndProps): JSX.Element => (
  <div styleName='container'>
    <img src='/resources/img/img_completion_trophy_light.svg' />
    <div styleName='heading'>{headingText}</div>
    {completionText && (
      <div styleName='subHeading'>
        <span>{completionText}</span>
      </div>
    )}
  </div>
);

export default CSSModules(End, styles);
